export const YIELD_COINS = ['BTC', 'ETH', 'USDT'];
export const YIELD_COIN_INFO = {
    BTC: { name: 'Bitcoin', icon: '₿', color: '#f7931a', dp: 8 },
    ETH: { name: 'Ethereum', icon: 'Ξ', color: '#627eea', dp: 8 },
    USDT: { name: 'USDT', icon: '₮', color: '#26a17b', dp: 2 },
};
/** Lock periods offered in the admin plan editor; any other number of days is a custom period. */
export const YIELD_TERMS = [
    { days: 0, label: 'Flexible' },
    { days: 30, label: '1 month' },
    { days: 90, label: '3 months' },
    { days: 180, label: '6 months' },
    { days: 365, label: '12 months' },
];
export const termLabel = (days) => YIELD_TERMS.find((t) => t.days === days)?.label ?? `${days} days`;
export const UNLOCK_REASONS = ['I need the funds', 'I want to trade with them', 'Change to another plan', 'Other'];
/** Interest in coin for `qty` at `apyPct` over `days` (simple, 365-day year). */
export const interestFor = (qty, apyPct, days) => (qty * apyPct * days) / 36500;
//# sourceMappingURL=yield.js.map